/*
 * 与手机客户端交互
 */
function setupWebViewJavascriptBridge(callback) {
  if (/Android/i.test(navigator.userAgent)) {
    // 安卓使用
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady'
        , () => {
          callback(WebViewJavascriptBridge);
        },
        false,
      );
    }
  } else {
    if (window.WebViewJavascriptBridge) {
      return callback(WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    const WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

const clientUtil = {

  /**
   * 此方法针对于安卓可以打开新的webview，628
   * @param {*} options
   * @param {*} callback
   */
  openNewWebPage(options, callback) {
    window.callback = callback || function (res) { };
    const jsonStr = JSON.stringify(options);
    if (/Android/i.test(navigator.userAgent)) {
      if (!window.Android) return;
      const res = Android.openNewWebPage(jsonStr);
      callback && callback(res);
    } else if (/iPhone/i.test(navigator.userAgent)) {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler('openNewWebPage', jsonStr, (response) => {
          callback && callback(JSON.stringify(response));
        });
      });
    }
  },
  
  // 跳转到登录页面
  gotoLogin () {
    const localHref = location.origin + location.pathname;
    if (/Android/i.test(navigator.userAgent)) {
      if (!window.Android) return;
      Android.pdllogin(localHref);
    } else if (/iPhone/i.test(navigator.userAgent)) {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler('pdllogin', localHref);
      });
    }
    return false;
  },

  // 获取用户状态，作为埋点的公参
  getUserState(callback) {
    let res;
    try {
      if (/Android/i.test(navigator.userAgent)) {
        if (!window.Android) return;
        res = Android.pdlGetUserstate();
        callback && callback(res);
      } else if (/iPhone/i.test(navigator.userAgent)) {
        setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler('pdlGetUserstate', '', (response) => {
            callback && callback(response);
          });
        });
      }
      return res;
    } catch (e) {
      console.log('pdlGetUserstate:', e);
    }
  },

  // 获取页面header信息通用函数
  getHeaders (callback) {
    try {
      if (/Android/i.test(navigator.userAgent)) {
        if (!window.Android) return;
        let res = Android.pdlheader();
        if (res) res = JSON.parse(res);
        callback && callback(res);
      } else if (/iPhone/i.test(navigator.userAgent)) {
        setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler('pdlheader', '', (response) => {
            callback && callback(response);
          });
        });
      }
    } catch (e) {
      throw e;
    }
  },

  // 关闭页面
	closePage() {
		if (/Android/i.test(navigator.userAgent)) {
			if (!window.Android) return;
			Android.hhfinish();
		} else if (/iPhone/i.test(navigator.userAgent)) {
			setupWebViewJavascriptBridge((bridge) => {
				bridge.callHandler('pdlfinish');
			});
		}
		return false;
	},
}

export default clientUtil;
